// src/services/clientService.js
import axios from "axios";
import { ApiLink } from "../APILink/ApiLink";
import authHeader from "../Auth/authHeader";

export const getAccountsDataByID = async (supplierid) => {
  const headers = authHeader();

  try {
    const response = await axios.get(
      `${ApiLink.API_URL}Accounts/accountsDataByID`,
      { headers, params: { id: supplierid } }
    );
    return response.data; // në vend që të bësh setState, kthen të dhënat
  } catch (error) {
    console.error("Gabim në kërkesë:", error);
    if (
      error.response &&
      error.response.data &&
      error.response.data.errorMessage
    ) {
      throw new Error(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
    } else if (error.message) {
      throw new Error(`Gabim: ${error.message}`);
    } else {
      throw new Error("Gabim i panjohur në kërkesë.");
    }
  }
};
